// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"82fdabd3","310":"70ca07f5","495":"08a545bf","653":"0247be42","694":"99329f59","713":"c8613f15","877":"be0d0314","910":"713c2be6","925":"af6281a1","965":"5d1d3b33"}[chunkId] + ".chunk.js";
};